// import { useState, useEffect } from "react";
// import { Footer, Navbar } from "../components";
// import { useSelector } from "react-redux";
// import { Link, parsePath } from "react-router-dom";
// import { PostDataAPI } from "../components/services/ApiServices";
import CheckoutForm from "./checkoutForm";
import Header from "../components/header";
import BookCover from "./../assets/img/book-cover.png";
import { PostDataAPI } from "../components/services/ApiServices";
import './../style.css';

// const Checkout = () => {
//   const state = useSelector((state) => state.handleCart);



//   useEffect(() => {

//   }, []);

//   const EmptyCart = () => {
//     return (
//       <div className="container">
//         <div className="row">
//           <div className="col-md-12 py-5 bg-light text-center">
//             <h4 className="p-3 display-5">No item in Cart</h4>
//             <Link to="/" className="btn btn-outline-dark mx-4">
//               <i className="fa fa-arrow-left"></i> Continue Shopping
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const ShowCheckout = () => {
//     let subtotal = 0;
//     let shipping = 0.5;
//     let totalItems = 0;
//     state.map((item) => {
//       return (subtotal += item.price * item.qty);
//     });

//     state.map((item) => {
//       return (totalItems += item.qty);
//     });



//     return (
//       <>


//         <div className="shop_container">
//           <div className="row my-4">
//             <div className="col-md-5 col-lg-5">
//               <div class="book-card">
//                 <div class="book-image">
//                   <div class="book-image-content">
//                     <img src={BookCover} alt="" width="100%" />
//                   </div>
//                 </div>

//                 {/* <h3 class="book-title-main">America 250</h3> */}

//                 <p class="book-description">
//                   Limited edition release of <span class="highlight-red" style={{fontSize: '24px'}}>1776</span> copies, each personally inscribed with a message from Ron DeSantis.
//                 </p>

//                 {/* <div class="book-details">
//                   <p class="mb-1"><span>Format:</span> Hardcover</p>
//                   <p class="mb-1"><span>Pages:</span> 256</p>
//                   <p class="mb-1"><span>Year:</span> 2026</p>
//                 </div> */}

//                 <div class="book-footer p-0">
//                   <p class="shipping-note">Free Shipping available to US addresses only</p>
//                   <div class="price">
//                     <span class="price-amount">$1776.00</span>

//                   </div>
//                 </div>
//               </div>


//               {/* <div className="card mb-4">
//                 <div className="card-header py-3 bg-light">
//                   <h5 className="mb-0">Order Summary</h5>
//                 </div>
//                 <div className="card-body">
//                   <ul className="list-group list-group-flush">
//                     <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
//                       Products ({totalItems})<span>${Math.round(subtotal)}</span>
//                     </li>
//                     <li className="list-group-item d-flex justify-content-between align-items-center px-0">
//                       Shipping
//                       <span>${shipping}</span>
//                     </li>
//                     <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
//                       <div>
//                         <strong>Total amount</strong>
//                       </div>
//                       <span>
//                         <strong>${Math.round(subtotal + shipping)}</strong>
//                       </span>
//                     </li>
//                   </ul>
//                 </div>
//               </div> */}
//             </div>
//             <div className="col-md-7 col-lg-7">
//               <CheckoutForm />
//             </div>

//           </div>
//         </div>
//       </>
//     );
//   };
//   return (
//     <>
//       <Header></Header>
//       <main className="hero">

//         <section className='shop_heading'>
//           <div className='shop_container'>
//             <div className='text-center my-4'>
//               <h2>Shop</h2>
//               <div className="divider"></div>
//             </div>
//           </div>

//           <ShowCheckout />
//         </section>

//       </main>
//       <Footer />
//     </>
//   );
// };

// export default Checkout;






import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Footer from "../components/Footer";

const IS_SOLD_OUT = true;



const Checkout = () => {
  const state = useSelector((state) => state.handleCart);

  useEffect(() => {
    if (IS_SOLD_OUT) return;

    const obj = {
      ProductId: 55
    }
    PostDataAPI('product/getCurrentQuantity', obj, true).then((result) => {
      if (result.success == true) {
        setTotalPrice(result.data.price)
      }
    });
  }, [])

  const [totalPrice, setTotalPrice] = useState()

  useEffect(() => { }, []);

  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">No item in Cart</h4>
            <Link to="/" className="btn btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const ShowCheckout = () => {
    return (
      <>
        <div className="shop_container">
          <div className="row my-4">
            <div className="col-md-5 col-lg-5">
              <div className="book-card">
                <div className="book-image">
                  <div className="book-image-content">
                    <img src={BookCover} alt="Book Cover" width="100%" />
                  </div>
                </div>
                <p className="book-description">

                  The America 250th Commemorative Edition of Dreams From Our Founding Fathers is individually numbered, personally hand-signed by Ron DeSantis, and limited to  <span className="highlight-red" style={{ fontSize: "24px" }}>
                    1776
                  </span>{" "} copies.

                </p>

                <div className="book-footer p-0">
                  {/* <p className="shipping-note">
                    Free Shipping available to US addresses only
                  </p> */}

                  <div className="price">
                    <span className="price-amount">
                      {IS_SOLD_OUT ? "SOLD OUT" : `$${totalPrice?.toLocaleString() + ".00"}`}
                    </span>


                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-7 col-lg-7">
              {IS_SOLD_OUT ? (
                <div className="checkout-sold-out-panel">
                  <h2>All Books Sold Out</h2>
                  <p>
                    Thank you for the incredible response to
                  </p>
                  <p className="sold-out-highlight-line">
                    Dreams from Our Founding Fathers – America 250
                  </p>
                  <p>
                    Commemorative Edition.
                  </p>
                  <p>
                    Our entire limited edition inventory has now been sold. We sincerely appreciate the overwhelming support and enthusiasm shown by readers across the country.
                  </p>
                  <p>
                    Thank you for being part of this historic release.
                  </p>
               
                </div>
              ) : (
                <CheckoutForm
                  setTotalPrice={setTotalPrice}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  };



  return (
    <>
      <Header />
      <main className="shop_page">
        <section className="shop_heading">
          <div className="shop_container">
            <div className="text-center my-4">
              <h2>Shop</h2>
              <div className="shop-divider"></div>
            </div>
          </div>

          <ShowCheckout />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Checkout;
